import React from 'react';
import { Navigate } from 'react-router-dom';
import LoginForm from './LoginForm.jsx';
import Navbar from "../Navbar.jsx";
import { useParams } from "react-router";
import PasswordRecovery from "./PasswordRecovery.jsx";
import {compareRole, iAmHigherAuthority} from "../../libs.jsx";
import './auth.css';
import { getSession } from "../../services/session";

const Landing = () => {

    let dData, bData, paramVars, container;

    paramVars = useParams();

    dData = getSession();

    if (paramVars?.dType === "recovery"){
        container = <PasswordRecovery />
    }else{
        container = <LoginForm />
    }

    return (dData?.slauth !== true && (dData?.tKey == null || dData?.tkey === "")) ? (
        <div className="auth-page">
            <Navbar />
            <main className="auth-content">
                {container}
            </main>
        </div>
        ) : dData?.acnt != null
            ?   dData.migrated
                ?   iAmHigherAuthority(10, dData.role_weight) ?  <Navigate to={"/dash/main"} /> : <Navigate to={"/alerts"} />
                :   compareRole("caregiver", dData.userrole) ? <Navigate to={"/dash/main"} /> : <Navigate to={"/alerts/emergency"} />
            : <Navigate to={"/dash/null"} />
    };

export default Landing;
